module.exports = __webpack_public_path__ + "img/icon-thin-arrow-secondary__down.20db12a6.svg";